import { useAuth } from '../context/AuthContext';

export default function ImpersonationBanner() {
  const { impersonating, stopImpersonation } = useAuth();
  if (!impersonating) return null;

  function handleReturn() {
    stopImpersonation();
    // hard redirect so the layout re-resolves cleanly as admin
    window.location.href = '/';
  }

  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 1000,
      background: 'linear-gradient(90deg,#8a2b00,#c0392b)', color: '#fff',
      padding: '10px 18px', display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: 16, fontSize: 14, fontWeight: 600, boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    }}>
      <span>👁️ You are viewing as <strong>{impersonating}</strong> — this is what they see.</span>
      <button onClick={handleReturn} style={{
        background: '#fff', color: '#c0392b', border: 'none', borderRadius: 6,
        padding: '6px 14px', fontWeight: 700, fontSize: 13, cursor: 'pointer',
      }}>↩ Return to admin</button>
    </div>
  );
}
